import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

export interface Props {
  inviting: () => void;
  submit: () => void;
  activationsRemaining: Maybe<number>;
}

function NextButton({ inviting, submit, activationsRemaining }: Props) {
  return activationsRemaining
    .map(() => (
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-teal-600 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={inviting}
      >
        <T kind="Next" />
      </div>
    ))
    .getOrElse(() => (
      <div
        className={clsx(
          'pointer-events-none rounded-md bg-gray-500 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={submit}
      >
        <T kind="Next" />
      </div>
    ));
}

export default observer(NextButton);
